import HeroSection from '../../sections/HeroSection/HeroSection';
import { ThemeProvider } from 'styled-components';
import theme from '../../global/theme';
import CTASection from '../../sections/CalltoActionSection/CalltoActionSection';
import { GlobalStyle } from '../../global/global';
import {
    Box,
    Flex,
    Text,
    Image,
    UnorderedList,
    ListItem,
    Link,
    List,
    ListIcon,
    Heading,
} from '@chakra-ui/react';
import FAQ from '../../sections/Faq/Faq';
import ChakraTilesSection from '../../sections/ChakraTilesSection/ChakraTilesSection';
import WhyService from '../../sections/WhyService/WhyService';
import BenefitsSectionWithImage from '../../sections/BenefitsSectionWithImage/BenefitsSectionWithImage';
import ExtendedTabsSection from '../../sections/ExtendedTabsSection/ExtendedTabsSection';
import { CheckIcon } from '@chakra-ui/icons';
import TilesSection from '../../sections/TilesSection/TilesSection';
import ContactSection from '../../sections/ContactSection/ContactSection';
import PlainSection from '../../sections/PlainSection/PlainSection';
import MigrationSection from '../../sections/MigrationSection/MigrationSection';
import ImageWithBoxSection from '../../sections/ImageWithBoxSection/ImageWithBoxSection';
import StyledButton from '../../components/Button/Button';
interface Props {}

const image = {
    url: 'https://www.idosell.com/panel/file-gate.php?id=319073&ext=.webp',
    alt: 'Zdjęcie wyróżniające w hero - strona eMag',
};

export default function EmagPage(props: Props) {
    return (
        <ThemeProvider theme={theme}>
            <GlobalStyle $whiteColor />
            <HeroSection
                type="integration"
                title="Integracja IdoSell z eMAG marketplace"
                subTitle={
                    <Text color={'white'} fontSize={'1.125rem'}>
                        Wejdź z ofertą na najpopularniejszy marketplace w Rumunii i dotrzyj do{' '}
                        <Text as={'span'} fontWeight={'700'}>
                            9 milionów potencjalnych klientów
                        </Text>{' '}
                        w trzech krajach: Rumunii, Bułgarii i na Węgrzech.{' '}
                    </Text>
                }
                badgeLabel="MARKETPLACE"
                image={image}
                integrationInfo={{
                    integrationCategory: 'Integracje  z IdoSell.',
                    integrationName: 'eMAG',
                    integrationHref:
                        'https://pomoc.idosell.com/marketplaces/emag/emag-instrukcja-konfiguracji',
                }}
            />
            <div className="homepage containerIdosellPages">
                <Box
                    py={{
                        base: 16,
                        md: 20,
                        xl: 24,
                    }}
                    display={'flex'}
                    flexDirection={{ base: 'column', xl: 'row' }}
                    gap={{
                        base: 6,
                        md: 12,
                    }}
                    position={'relative'}
                >
                    <TilesSection
                        title={'Ciesz się wszystkimi możliwościami eMAG marketplace'}
                        tiles={[
                            {
                                title: 'Łatwe wejście na nowe rynki',
                                content:
                                    'Wykorzystaj ogromny potencjał eMAG marketplace, który ma aż 120 mln odwiedzin miesięcznie. Dzięki temu z łatwością wejdziesz na rynki w Rumunii, Bułgarii i na Węgrzech.',
                            },
                            {
                                title: 'Gotowa baza klientów',
                                content:
                                    'eMAG to ponad 9 mln aktywnych klientów miesięcznie. Zacznij sprzedawać na najpopularniejszym marketplace w Rumunii i rozszerz sprzedaż o nowe rynki.',
                            },
                            {
                                title: 'Wygodne zarządzanie ofertami',
                                content:
                                    'Wygodnie zarządzaj ofertami, które prezentujesz na eMAG marketplace - wszystkie transakcje obsłużysz z poziomu panelu IdoSell.',
                            },
                        ]}
                    />
                </Box>
                <Box
                    py={{
                        base: 16,
                        md: 20,
                        xl: 24,
                    }}
                    display={'flex'}
                    flexDirection={{ base: 'column', xl: 'row' }}
                    gap={{
                        base: 6,
                        md: 12,
                    }}
                    position={'relative'}
                >
                    <PlainSection
                        title="W Rumunii zakupy zaczynają się na eMAG-u"
                        text={
                            <>
                                <Text mb={'15px'}>
                                    Wykorzystaj ogromną bazę klientów, którzy regularnie robią
                                    zakupy na platformie eMAG i prezentuj swoje oferty na
                                    najpopularniejszym marketplace w Rumunii. Dzięki integracji
                                    IdoSell z eMAG z łatwością dotrzesz do konsumentów z trzech
                                    krajów: Rumunii, Bułgarii i Węgier.
                                </Text>
                                <Text>
                                    <Text display={'inline'} fontWeight={'900'}>
                                        eMAG marketplace to ponad 120 mln odwiedzin miesięcznie oraz
                                        ponad 9 mln aktywnych użytkowaników.
                                    </Text>{' '}
                                    Platforma skupia obecnie ponad 56 tys. sprzedawców, a ich liczba
                                    stale rośnie. Jeśli myślisz o wyjściu z ofertą na nowe rynki,
                                    eMAG jest doskonałym sposobem na dotarcie do wielu aktywnych
                                    klientów za granicą.{' '}
                                </Text>
                            </>
                        }
                        buttons={[
                            {
                                title: 'Rozpocznij już teraz',
                                href: 'https://pomoc.idosell.com/marketplaces/emag/emag-instrukcja-konfiguracji',
                                variant: 'default',
                            },
                        ]}
                        image={{
                            alt: 'Zdjęcie ze strony eMag',
                            url: 'https://www.idosell.com/panel/file-gate.php?id=319074&ext=.jpg',
                            mobile: {
                                url: 'https://www.idosell.com/panel/file-gate.php?id=323059&ext=.jpg',
                            },
                            desktop: {
                                url: 'https://www.idosell.com/panel/file-gate.php?id=319074&ext=.jpg',
                            },
                        }}
                    />
                </Box>
                <Box
                    py={{
                        base: 16,
                        md: 20,
                        xl: 24,
                    }}
                    display={'flex'}
                    flexDirection={'column'}
                    gap={'50px'}
                    position={'relative'}
                >
                    <WhyService
                        title="Dotrzyj do milionów klientów, którzy kupują na eMAG-u"
                        list={[
                            {
                                featuredMainNumber: '9',
                                featuredAddingNumber: ' mln',
                                featuredText: 'aktywnych klientów miesięcznie',
                            },
                            {
                                featuredMainNumber: '120',
                                featuredAddingNumber: ' mln',
                                featuredText: 'odwiedzin marketplace miesięcznie',
                            },
                        ]}
                    />
                </Box>
                <Box
                    py={{
                        base: 16,
                        md: 20,
                        xl: 24,
                    }}
                    display={'flex'}
                    flexDirection={'column'}
                    gap={'35px'}
                    position={'relative'}
                >
                    <BenefitsSectionWithImage
                        title="Sprzedawaj na eMAG dzięki wbudowanej integracji IdoSell"
                        layoutSchema="3x1"
                        type="check2"
                        benefits={[
                            {
                                benefitsTitle: 'Tworzenie kart produktu w katalogu eMAG',
                            },
                            {
                                benefitsTitle:
                                    'Dodanie istniejącego produktu do oferty w katalogu eMAG',
                            },
                            {
                                benefitsTitle: 'Pobieranie zamówień',
                            },
                            {
                                benefitsTitle: 'Aktualizacja stanów magazynowych',
                            },
                            {
                                benefitsTitle: 'Aktualizacja cen',
                            },
                            {
                                benefitsTitle: 'Mapowanie kurierów eMAG',
                            },
                            {
                                benefitsTitle: 'Wysyłka faktur',
                            },
                            {
                                benefitsTitle: 'Wysyłka statusów',
                            },
                            {
                                benefitsTitle: 'i wiele więcej!',
                            },
                        ]}
                    />
                </Box>
                <Box>
                    <ImageWithBoxSection
                        image={{
                            url: 'https://www.idosell.com/panel/file-gate.php?id=319140&ext=.jpeg',
                        }}
                        boxSide="right"
                        rightSection={
                            <>
                                <Text
                                    fontSize={'26px'}
                                    lineHeight={'34px'}
                                    color={'white'}
                                    textAlign={'center'}
                                    mb={'30px'}
                                    fontWeight={'700'}
                                >
                                    Dotrzyj do milionów klientów bez obaw o koszty czy logistykę!
                                </Text>
                                <Text color={'white'} mb="30px">
                                    Zero kosztów wystawienia i pieniądze bezpośrednio na koncie - na
                                    eMAG-u płacisz prowizję tylko od tego, co sprzedasz.
                                </Text>
                                <Text color={'white'} mb="30px">
                                    Dzięki rozbudowanej integracji IdoSell z eMAG-iem nie martwić
                                    się o bazę klientów ani o logistykę. Dzięki integracji z Packetą
                                    wyślesz swoje przesyłki tanio i bezpiecznie.
                                </Text>
                            </>
                        }
                        leftSection={
                            <>
                                <Heading
                                    as={'h2'}
                                    fontWeight={'600'}
                                    fontSize={'2.125rem'}
                                    lineHeight={'3rem'}
                                    marginBottom={'15px'}
                                    color={'white'}
                                >
                                    Jak sprzedawać na eMAG-u?
                                </Heading>
                                <Text color={'white'} mb="30px">
                                    Na platformie eMAG zarejestrujesz się za pomocą kilku kliknięć.
                                    Wystarczy mieć dane firmy pod ręką. Wszystko odbywa się w języku
                                    polskim.
                                </Text>
                                <StyledButton
                                    href={'https://www.emag.ro/lps/earn-more-pl-idosell'}
                                    style={'outline-reverted'}
                                    target="_blank"
                                >
                                    Załóż konto na eMAG
                                </StyledButton>
                            </>
                        }
                    />
                </Box>
                <Box
                    py={{
                        base: 16,
                        md: 20,
                        xl: 24,
                    }}
                    display={'flex'}
                    flexDirection={'column'}
                    gap={'35px'}
                    position={'relative'}
                >
                    <ContactSection />
                </Box>
            </div>
        </ThemeProvider>
    );
}
